define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var AppConfig = require('config/application');

    var State = Backbone.Model.extend({
        defaults: {
            showOverlay: false,
            opened: false
        }
    });

    return Marionette.Object.extend({
        initialize: function() {
            this.model = new State();
            this.listenTo(app.Vents, 'sideCard:show', this.show);
            this.listenTo(app.Vents, 'sideCard:hide', this.hide);
            this.listenTo(app.Vents, 'route:changed', this.hide);
            this.listenTo(this.model, 'change:opened', this.onChangeOpened);
            this.listenTo(this.model, 'change:showOverlay', this.onChangeShowOverlay);
            this.listenTo(this.model, 'change:hideClose', this.onChangeHideClose);

            $('.js-sidecard-close').click(this.onClickClose.bind(this));
            $(window).on('hashchange', this.hide.bind(this));
        },

        show: function(view, options) {
            var sideCardView = typeof view == 'function' ? new view() : view;
            options = options || {};

            this.model.set('showOverlay', !!options.showOverlay);
            this.model.set({
                opened: true,
                hideClose: !!options.hideClose,
            });
            app.regionSideCard.show(sideCardView);
        },

        hide: function() {
            this.model.set('opened', false);
            this.model.set('showOverlay', false);
            app.regionSideCard.empty();
        },

        onChangeOpened: function() {
            var opened = this.model.get('opened');

            $('.js-sidecard-region').toggleClass('sidecard-region--open', opened);
        },

        onChangeShowOverlay: function() {
            var showOverlay = this.model.get('showOverlay');

            $('.js-sidecard-overlay').toggleClass('sidecard-overlay--open', showOverlay);
        },

        onChangeHideClose: function() {
            var state = !this.model.get('hideClose');

            $('.js-sidecard-close').toggle(state);
        },

        onClickClose: function() {
            var currentView = app.regionSideCard.currentView;
            if (currentView.onBeforeClose) {
                currentView.onBeforeClose().then(this.hide.bind(this)).catch(() => {});
            } else {
                this.hide();
            }
        }
    })
});